import {useMutation, useQuery} from '@tanstack/react-query';
import {
  IDocumentMediaAddEditRemarkRequest,
  IDocumentMediaAddEditRemarkResponse,
  IDocumentMediaRemark,
  IDocumentMediaRemarkRequest,
} from '../../api/types/document.type';
import {
  addEditMediaRemarks,
  getMediaRemarks,
} from '../../api/endpoints/documentApi';
import {AxiosError} from 'axios';

export const useDocumentMediaRemarks = (
  params: IDocumentMediaRemarkRequest,
  enabled: boolean
) => {
  return useQuery<IDocumentMediaRemark[]>({
    queryKey: ['mediaRemarks', params],
    queryFn: () => getMediaRemarks(params),
    enabled,
  });
};

export const useDocumentMediaAddEditRemarks = () => {
  return useMutation<
    IDocumentMediaAddEditRemarkResponse,
    AxiosError,
    IDocumentMediaAddEditRemarkRequest
  >({
    mutationFn: addEditMediaRemarks,
    mutationKey: ['addEditMediaRemarks'],
  });
};
